<template>
    <div>
        <Form
            :formContent="formContent"
            @updateForm="updateForm($event)"
            @updateButton="updateButton($event)"
            @updateMessage="updateMessage($event)"
            @updateRedirect="updateRedirect($event)"
            @updateEmailReply="updateEmailReply($event)"
         />
        <!-- <div class="row">
        </div>
        <div class="row">
            <div v-for="(item, index) in formContent.frameContent.content" :key="index" :class="normalizeClass(item.type)">
                <BaseInput v-if="item.type != 'textarea'" :inputType="item.type" :inputPlaceholder="item.title"></BaseInput>
                <BaseTextArea v-else :inputPlaceholder="item.title"></BaseTextArea>
            </div>
        </div>
        <div class="row">
            <div class="text-right pull-right">
                <BaseButton :labelButton="formContent.frameContent.submit"></BaseButton>
            </div>
        </div> -->
    </div>
</template>

<script>
import BaseInput from '@/components/blocks/BaseInput.vue';
import BaseTextArea from '@/components/blocks/BaseTextArea.vue';
import BaseButton from '@/components/blocks/BaseButton.vue';
import Form from '@/components/organisms/Form.vue'
export default {
    props:{
        formContent:{
            type:Object,
        }
    },
    components: {
        BaseInput,
        BaseButton,
        BaseTextArea,
        Form
    },
    methods:{
        normalizeClass,
        updateForm,
        updateButton,
        updateMessage,
        updateRedirect,
        updateEmailReply
    },
    created(){
        this.dataProps = this.formContent
    },
}
function normalizeClass(itemType){
    let totalClass = null
    if(itemType == 'textarea'){
        totalClass = 'col-12'
    }else{
        totalClass = 'col-12 col-lg-6'
    }
    return totalClass
}
function updateForm(event) {
    this.formContent.frameContent.content = event;
}
function updateButton(event) {
    this.formContent.frameContent.submit = event;
}
function updateMessage(event) {
    this.formContent.frameContent.message = event;
}
function updateRedirect(event) {
    this.formContent.frameContent.redirect = event;
}
function updateEmailReply(event) {
    this.formContent.frameContent.emailReply = event;
}
</script>

<style scoped>
    input{
        width: 100%;
        text-align: left!important
    }
    textarea{
        width: 100%;
        text-align: left!important
    }
</style>



// WEBPACK FOOTER //
// src/components/blocks/FormComponent.vue